// https://cdn.jsdelivr.net/npm/@alpinejs/resize@3.x.x/dist/cdn.min.js

(() => {
  function u(e) {
    e.directive(
      "resize",
      e.skipDuringClone(
        (
          t,
          { value: i, expression: n, modifiers: o },
          { evaluateLater: r, cleanup: h }
        ) => {
          let f = r(n),
            s = (z, m) => {
              f(() => {}, { scope: { $width: z, $height: m } });
            },
            v = o.includes("document") ? b(s) : a(t, s);
          h(() => v());
        }
      )
    );
  }
  function a(e, t) {
    let i = new ResizeObserver((n) => {
      let [o, r] = c(n);
      t(o, r);
    });
    return i.observe(e), () => i.disconnect();
  }
  var d,
    l = new Set();
  function b(e) {
    return (
      l.add(e),
      d ||
        ((d = new ResizeObserver((t) => {
          let [i, n] = c(t);
          l.forEach((o) => o(i, n));
        })),
        d.observe(document.documentElement)),
      () => {
        l.delete(e);
      }
    );
  }
  function c(e) {
    let t, i;
    for (let n of e)
      (t = n.borderBoxSize[0].inlineSize), (i = n.borderBoxSize[0].blockSize);
    return [t, i];
  }
  document.addEventListener("alpine:init", () => {
    window.Alpine.plugin(u);
  });
})();
